import Service from "@/helpers/py-service";

const state = {
  loading: false,
  meta: {},
  list: [],
  //
  isDetailLoading: false,
  details: [],
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_DETAILS(state, payload) {
    state.details = payload;
  },
};

const actions = {
  list: (store, params) => {
    store.state.loading = true;
    // return Service.get(`routes/transit-report-listing`, params)
    return Service.get(`routes/transit-report-listing-v2`, params)
      .then((data) => {
        store.commit("SET_META", data.body);
        store.commit("SET_LIST", data.body.data);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
  details: (store, params) => {
    store.state.isDetailLoading = true;
    return Service.get(`routes/transit-report-details`, params)
      .then((data) => {
        store.commit("SET_DETAILS", data?.body?.trip_details);
        return data.body;
      })
      .finally(() => (store.state.isDetailLoading = false));
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  meta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
  getIsDetail(state) {
    return state.isDetailLoading;
  },
  getDetails(state) {
    return state.details;
  },
};

const transitReport = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default transitReport;
